export default function User() {
  return (
    <div>
      <h2>用户中心</h2>
      <p>Hello World from User!</p>
    </div>
  );
}
